import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import VehicleTypeListPageUI from './VehicleTypeListPageUI.js'

class VehicleTypeListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      vehicleTypeList: null,
      updateVehicleTypeMode: false
    }
  }

  render() {
    return (
      <VehicleTypeListPageUI
        context={this.props.context}
        loan={this.state.loan}
        errorList={this.state.errorList}
        onRefreshClick={this.onRefreshClick}
        filteredVehicleTypeList={this.state.filteredVehicleTypeList}
        updateVehicleTypeMode={this.state.updateVehicleTypeMode}
        onVehicleTypeUpdateClick={() => { this.setState({ updateVehicleTypeMode: true }) }}
        onVehicleTypeUpdateCancel={() => { this.setState({ updateVehicleTypeMode: false }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getVehicleTypeList(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({
      errorList: response.errorList, loan: response.loan, vehicleTypeList: response.loan.vehicleTypeList
    })
  }

  getVehicleTypeList(context) {
    let cacheManager = new CacheManager({
      resource: `/api/reference/vehicleTypes`,
      cacheKey: CacheKeys.VehicleType(),
      callback: this.getVehicleTypeListCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getVehicleTypeListCallback = (response) => {
    let vehicleList = response.vehicleTypeList.map((vehicle) => {
      return { key: vehicle.vehicleType, value: vehicle.vehicleTypeName }
    });
    this.setState({ errorList: response.errorList, filteredVehicleTypeList: vehicleList })
  }

  onRefreshClick = () => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
    CacheManager.removeObject(CacheKeys.VehicleType())
    this.setState({
      loan: null,
      errorList: null,
    })
    this.getLoan(context)
    this.getVehicleTypeList(context)
  }
}

export default withRouter(VehicleTypeListPageSF)
